import React from 'react';

/**
 * Pre-flight check: the prompt travels unchanged while standing guidance and
 * constitutional instructions assemble around it into one request, which only
 * runs if the required instructions are present.
 */
export function ConstitutionalFlow() {
  return <div style={{
    width: '100%',
    maxWidth: 460,
    margin: '0 auto'
  }} data-id="element-101" data-mp="3e39n5t53yjqh">
      {/* The top row sits flush at x=0 / y=0, so the viewBox carries a 1px bleed;
          without it those strokes are half-clipped and render thinner than the rest. */}
      <svg viewBox="-1 -1 482 398" width="100%" fill="none" fontFamily="JetBrains Mono, monospace" role="img" aria-label="The prompt is left unchanged; standing guidance and constitutional instructions assemble around it into an instruction-assembled request. If the required instructions are included, a signed receipt is recorded and the request is sent to the model; if not, the request is blocked and the failure logged." data-id="element-102" data-mp="3rvg43hg34uqz">
        <rect x="0" y="0" width="148" height="46" fill="#fff" stroke="#CCD2DA" strokeWidth="1.2" data-id="element-103" data-mp="2lpivi2u5cauf" />
        <text x="74" y="19.5" textAnchor="middle" fill="#49515B" fontSize="12" data-id="element-104" data-mp="2gxqzhcs81cww">
          prompt
        </text>
        <text x="74" y="33.5" textAnchor="middle" fill="#7B838D" fontSize="9.5" data-id="element-105" data-mp="2byei37k4cy1p">
          (unchanged)
        </text>
        <rect x="166" y="0" width="148" height="46" fill="#fff" stroke="#CCD2DA" strokeWidth="1.2" data-id="element-106" data-mp="27yvshyhcrysj" />
        <text x="240" y="19.5" textAnchor="middle" fill="#49515B" fontSize="12" data-id="element-107" data-mp="34mjxrfwbfwuo">
          standing
        </text>
        <text x="240" y="33.5" textAnchor="middle" fill="#49515B" fontSize="12" data-id="element-108" data-mp="2zpjsv8b7d055">
          guidance
        </text>
        <rect x="332" y="0" width="148" height="46" fill="#fff" stroke="#8A929B" strokeWidth="1.2" data-id="element-109" data-mp="2vozy2be3q8m6" />
        <text x="406" y="19.5" textAnchor="middle" fill="#151A21" fontSize="12" data-id="element-110" data-mp="2qqevw6fahev3">
          constitutional
        </text>
        <text x="406" y="33.5" textAnchor="middle" fill="#151A21" fontSize="12" data-id="element-111" data-mp="1f96qpiwtjupv">
          instructions
        </text>

        <line x1="74" y1="46" x2="74" y2="66" stroke="#CCD2DA" strokeWidth="1.2" data-id="element-112" data-mp="1gpt0ago40vbe" />
        <line x1="406" y1="46" x2="406" y2="66" stroke="#CCD2DA" strokeWidth="1.2" data-id="element-113" data-mp="1loxanamrsz3b" />
        <line x1="74" y1="66" x2="406" y2="66" stroke="#CCD2DA" strokeWidth="1.2" data-id="element-114" data-mp="17peap5444u23" />
        <line x1="240" y1="46" x2="240" y2="84" stroke="#CCD2DA" strokeWidth="1.2" data-id="element-115" data-mp="17rqr3du82wd1" />
        <polygon points="240,90 236.5,83.5 243.5,83.5" fill="#CCD2DA" data-id="element-116" data-mp="1bp6dt2aqm802" />

        <rect x="150" y="90" width="180" height="46" fill="#fff" stroke="#CCD2DA" strokeWidth="1.2" data-id="element-117" data-mp="xyt3wueacj83" />
        <text x="240" y="109.5" textAnchor="middle" fill="#49515B" fontSize="12" data-id="element-118" data-mp="12r33711aivn1">
          instruction
        </text>
        <text x="240" y="123.5" textAnchor="middle" fill="#49515B" fontSize="12" data-id="element-119" data-mp="o388xg7mwj7u">
          assembled request
        </text>
        <line x1="240" y1="136" x2="240" y2="150" stroke="#CCD2DA" strokeWidth="1.2" data-id="element-120" data-mp="sy5ico8tsul9" />
        <polygon points="240,156 236.5,149.5 243.5,149.5" fill="#CCD2DA" data-id="element-121" data-mp="f2tjc4nn0hyj" />

        <rect x="110" y="156" width="260" height="38" fill="#fff" stroke="#CCD2DA" strokeWidth="1.2" strokeDasharray="4 3" data-id="element-122" data-mp="jzaa76m81afb" />
        <text x="240" y="178.5" textAnchor="middle" fill="#49515B" fontSize="11.5" data-id="element-123" data-mp="3rm5tq81m6sc7">
          required instructions included?
        </text>

        <line x1="185" y1="194" x2="185" y2="222" stroke="#0E6FA3" strokeWidth="1.2" data-id="element-124" data-mp="5clbh6zsn19z" />
        <rect x="166" y="222" width="38" height="20" rx="10" fill="#fff" stroke="#0E6FA3" strokeWidth="1.2" data-id="element-125" data-mp="jcvzm29py1rg" />
        <text x="185" y="236" textAnchor="middle" fill="#0F5480" fontSize="10.5" data-id="element-126" data-mp="eeb1q9hxvu66">
          yes
        </text>
        <line x1="185" y1="242" x2="185" y2="262" stroke="#0E6FA3" strokeWidth="1.2" data-id="element-127" data-mp="t2ysm2gubfps" />
        <polygon points="185,268 181.5,261.5 188.5,261.5" fill="#0E6FA3" data-id="element-128" data-mp="o32om3857oa8" />
        <rect x="75" y="268" width="220" height="52" fill="#fff" stroke="#0E6FA3" strokeWidth="1.2" data-id="element-129" data-mp="o5yp9zbdkr2d" />
        <text x="185" y="297.5" textAnchor="middle" fill="#0F5480" fontSize="12" data-id="element-130" data-mp="12114xe60xusd">
          record signed receipt
        </text>
        <line x1="185" y1="320" x2="185" y2="342" stroke="#0E6FA3" strokeWidth="1.2" data-id="element-131" data-mp="2rl0ug93srabt" />
        <polygon points="185,348 181.5,341.5 188.5,341.5" fill="#0E6FA3" data-id="element-132" data-mp="2wjc86ux7q4zb" />
        <rect x="95" y="348" width="180" height="36" fill="#151A21" data-id="element-133" data-mp="2wh96hdmp6ner" />
        <text x="185" y="370" textAnchor="middle" fill="#fff" fontSize="12" data-id="element-134" data-mp="31au6tcbrjth4">
          send request to model
        </text>

        <path d="M370 175 L412 175 L412 222" stroke="#C2543C" strokeWidth="1.2" fill="none" data-id="element-135" data-mp="35dqjynijaxdo" />
        <rect x="395" y="222" width="34" height="20" rx="10" fill="#fff" stroke="#C2543C" strokeWidth="1.2" data-id="element-136" data-mp="28nq0n40xp93r" />
        <text x="412" y="236" textAnchor="middle" fill="#b8492e" fontSize="10.5" data-id="element-137" data-mp="2dmkpamll1rvs">
          no
        </text>
        <line x1="412" y1="242" x2="412" y2="262" stroke="#C2543C" strokeWidth="1.2" data-id="element-138" data-mp="2mlekc8j9ma78" />
        <polygon points="412,268 408.5,261.5 415.5,261.5" fill="#C2543C" data-id="element-139" data-mp="2mj1u783cstj3" />
        <rect x="332" y="268" width="148" height="52" fill="#fff" stroke="#C2543C" strokeWidth="1.2" data-id="element-140" data-mp="3t18g0v8u0hmg" />
        <text x="406" y="290.5" textAnchor="middle" fill="#b8492e" fontSize="12" data-id="element-141" data-mp="1tcgiyedzdrz">
          block request,
        </text>
        <text x="406" y="304.5" textAnchor="middle" fill="#b8492e" fontSize="12" data-id="element-142" data-mp="c0ym998bk0sk">
          log failure
        </text>
      </svg>
    </div>;
}